import { IPaymentSlipDTO } from '~models/PaymentSlip/PaymentSlip';
import HttpService from '~/services/httpService';

const get = HttpService.get;
const baseUrl = 'invoices/payment-slips';

async function getPaymentSlips(resellerDocument: string, params?: any) {
  return await get(baseUrl, { params: { ...params, resellerDocument } }).then(
    (response) => {
      if (response.data.success) {
        return {
          paymentSlipList: response.data.data.map(
            (paymentSlipsDto: IPaymentSlipDTO) => new PaymentSlip(paymentSlipsDto),
          ),
          pagination: { ...response.data.metadata.pagination },
        };
      } else {
        return response.data;
      }
    },
    (error) => {
      throw errorTreatment(error);
    },
  );
}

export async function listPaymentSlips(resellerDocument: string) {
  return await getPaymentSlips(resellerDocument);
}

export async function filterPaymentSlips(
  resellerDocument: string,
  filters: any,
  pagination = { ...PAGINATION },
) {
  try {
    const params = adaptQueryParams<any, any>(
      filters,
      pagination,
      preparePaymentSlipListFilterParams_v2,
    );

    return await getPaymentSlips(resellerDocument, params);
  } catch (error) {
    throw errorTreatment(error);
  }
}

export async function getPaymentLink(
  resellerDocument: string,
  invoiceNumber: string,
  invoiceSerieNumber: string,
) {
  return await get('payments', {
    params: {
      resellerDocument,
      invoiceNumber,
      invoiceSerieNumber,
    },
  }).then((response: any) => response.data);
}
